import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DeploymentsResource {
    baseUrl: string;
    resourceName = 'deployments';

    constructor(private http: HttpClient) {
        this.baseUrl = [environment.baseUrl, 'v2', this.resourceName].join('/');
    }

    findById(id: string): Observable<any> {
        return this.http.get<any>(this.baseUrl + '/' + id);
    }

    list(stage?: 'Development' | 'Staging' | 'Production' | 'All', limit?: number, offset?: number): Observable<any> {
        const millisecondsInADay = 24 * 60 * 60 * 1000;
        const now = new Date();
        const past = new Date(now.getTime() - 7 * millisecondsInADay);
        const url = new URL(this.baseUrl + `/list`);
        url.searchParams.set('from', past.toISOString());
        url.searchParams.set('until', now.toISOString());

        if (limit) url.searchParams.set('limit', `${limit}`);
        if (offset) url.searchParams.set('offset', `${offset}`);
        if (stage && stage !== 'All') url.searchParams.set('stageFilter', stage);

        return this.http.get<any>(url.toString());
    }
}
